import {Component, EventEmitter, Input, Output} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-datepicker',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './date-picker.cmp.html'
})
export class DatePickerCmp {
  @Input() value: Date;
  @Input() placeholder: string = 'SelectDate';
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<Date>();

  formatDateForInput(date: Date): string {
    if (!date) return '';
    const pad = (n: number) => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are 0-based
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  changeHour($event: Event) {
    const value = ($event.target as HTMLInputElement).value;
    const newValue = new Date(value);
    if (newValue != this.value) {
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }
}
